export default "__VITE_ASSET__EHpMIdMp__"